// extracted by mini-css-extract-plugin
export default {"mainHeader":"header_mainHeader__h0Tku","userManagementContainer":"header_userManagementContainer__xeOe0"};